import { FileField } from "./AssociateFields";

// Old-system documents that have no matching upload box (e.g. Associate Form, BSE File, older versions).
export const legacyLeft = (profile) => {
  const used = new Set(Object.values(profile || {}).flatMap((s) => (s && typeof s === "object" && !Array.isArray(s) ? Object.values(s) : []))
    .filter((v) => v && v.storage_path).map((v) => v.storage_path));
  return ((profile || {}).legacy_documents || []).filter((d) => !used.has(d.storage_path));
};

export const LegacyDocs = ({ ctx, profile }) => {
  const docs = legacyLeft(profile);
  if (!docs.length) return <p className="py-8 text-center text-sm text-gray-500" data-testid="associate-legacy-empty">No expired or outdated documents.</p>;
  return (
    <section className="space-y-3" data-testid="associate-legacy-docs">
      <h3 className="text-xs font-bold uppercase tracking-wider text-rose-700">Expired &amp; Outdated Documents</h3>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {docs.map((d, i) => (
          <div key={d.legacy_key || i} data-testid={`associate-legacy-doc-${i}`}>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-gray-500">{d.label}</label>
            <FileField fl={{ key: `legacy_${i}`, label: d.label }} value={d} ro ctx={ctx} />
          </div>
        ))}
      </div>
    </section>
  );
};
